






































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ModalBuatKonsul from "@/components/modal/CardModalBuatKonsul.vue";
import CardModalJawabKonsul from "@/components/modal/CardModalJawabKonsul.vue";
import CardListSuratKonsul from "@/components/pemeriksaan/konsulRujukan/CardListSuratKonsul.vue";
import { storeUnit } from "@/store/modules/unit";
import { storeKonsul } from "@/store/modules/konsul";
import { storeSoap } from "@/store/modules/soap";
// import User from "@/utility/User";
import { userModule } from "@/store/modules/user";
// import http from "@/axios/http-common";
import { appModule } from "@/store/modules/app";
@Component({
  components: {
    ModalBuatKonsul,
    CardModalJawabKonsul,
    CardListSuratKonsul
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSuratKonsul extends Vue {
  @Prop() register!: string;
  @Prop() tab!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  modalOpenKonsul = false;
  modalJawabKonsul = false;
  sess_login = this.stateuser;
  dataKonsul = null;
  jwbKonsul = null;
  panel: [];

  created() {
    storeUnit.act_on_all_pagi();
    // storeKonsul.getKonsulMasuk(this.register);
  }

  mounted() {
    storeKonsul.actKonsul_on_reg(this.register);
    storeKonsul.getKonsulMasuk(this.register);
  }

  get stateuser() {
    return userModule.user;
  }
  // get statekonsul() {
  //   return storeKonsul.konsul;
  // }

  get statedetailkonsul() {
    return storeKonsul.detailkonsul;
  }

  // get statejawabkonsul() {
  //   return storeKonsul.jwbkonsul;
  // }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get statesoapalldokter() {
    return storeSoap.soapAll;
  }

  get statesoapperawat() {
    return storeSoap.detailSoap;
  }

  get outbox() {
    return this.statedetailkonsul.filter(this.filterOut);
  }

  get inbox() {
    return storeKonsul.konsulMasuk.filter(this.filterIn);
  }

  filterOut(element) {
    return (
      element.unit_pengirim.id == this.stateuser.unit_group_id ||
      element.unit_pengirim.id == this.stateuser.unit_id
    );
  }

  filterIn(element) {
    return (
      (element.unit_tujuan.id == this.stateuser.unit_group_id &&
        element.aktif == "1") ||
      (element.unit_tujuan.id == this.stateuser.unit_id && element.aktif == "1")
    );
  }

  tambah() {
    if (
      this.canMakeKonsul &&
      ((this.stateuser.unit_id != "01" && this.statesoapdetail.length > 0) ||
        this.stateuser.unit_id == "01")
    ) {
      this.dataKonsul = null;
      this.modalOpenKonsul = true;
    } else {
      appModule.sendErrorAlert(
        "Mohon isi Catatan SOAP terlebih dahulu sebelum membuat Surat Rujukan Internal"
      );
    }
  }

  get canMakeKonsul() {
    if (this.readOnly) return false;
    return (
      this.stateuser?.profesi.toLowerCase() == "dokter" ||
      this.stateuser?.profesi.toLowerCase() == "perawat" ||
      this.stateuser?.profesi.toLowerCase() == "bidan"
    );
  }

  closePanel() {
    this.panel = [];
  }
}
